<template>
  <div>
    <div :class="{'d-flex flex-wrap': flex}">
      <div
        v-for="(item, index) in items"
        v-bind:key="index"
        :class="{'mr-2': flex}"
        v-bind:style="{ width: flexWidth, maxWidth: flexWidth }"
      >
        <div class="input-group mb-1" :class="[sizeVal]">
          <div class="input-group-prepend input-group-prepend-list-editor" v-if="showIndex">
            <span class="input-group-text">
              <span v-if="prefix">{{prefix}}</span>
              {{index+1}}
              <span v-if="m">/{{m}}</span>
            </span>
          </div>
          <input type="text" class="form-control" v-model="items[index]" :disabled="disabled">
          <div class="input-group-append" v-if="!required">
            <span class="input-group-text pt" @click="deleteItem(index)" :title="deleteTooltip">x</span>
          </div>
        </div>
      </div>
    </div>
    <b-button
      type="button"
      variant="brand"
      class="btn-sm mt-1"
      @click="addItem()"
      v-if="!required && items.length < max"
    >{{addLabel}}</b-button>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    addLabel: {
      type: String,
      default: () => "Add New Item"
    },
    deleteTooltip: {
      type: String,
      default: () => "Delete Item"
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    required: {
      type: Boolean,
      default: () => false
    },
    showIndex: {
      type: Boolean,
      default: () => false
    },
    m: {
      type: String,
      default: () => ""
    },
    prefix: {
      type: String,
      default: () => ""
    },
    max: {
      type: Number,
      default: () => Number.MAX_SAFE_INTEGER
    },
    size: {
      type: String,
      default: ""
    },
    flex: {
      type: Boolean,
      default: false
    },
    flexWidth: {
      type: String,
      default: ""
    }
  },
  computed: {
    sizeVal() {
      return this.size ? `input-group-${this.size}` : "";
    }
  },
  methods: {
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    addItem(index) {
      this.items.push("");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
